export default __webpack_public_path__ + "2a674fa32dbfc6edc269a9bbe20013d3.png";